import React, { Component } from 'react';
import Filtro               from './renderFiltro';

class renderFilter extends Component {
    render() {
        return (
            <div className="row">
                    <div className="col-12">
                        <div className="quest-filtering">
                            <div className="quest-filtering-actions">
                             <Filtro/>
                            </div>
                        </div>
                    </div>
                </div>
        );
    }
}

export default renderFilter;


// WEBPACK FOOTER //
// ./src/container/renderFilter.js